import classNames from 'classnames';
import * as React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Space from '../space';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DetailTitle = props => {
  var _desc$filter;
  const {
    icon,
    title,
    desc,
    actions,
    divider,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-detailTitle");
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(baseClassName, className, divider ? "".concat(baseClassName, "-divider") : ''),
    style: style,
    children: [icon && /*#__PURE__*/_jsx("div", {
      className: "icon",
      children: icon
    }), /*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "title-row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "title",
          children: title
        }), !!actions && /*#__PURE__*/_jsx(Space, {
          size: "l",
          className: "actions",
          children: actions === null || actions === void 0 ? void 0 : actions.map((action, index) => action && /*#__PURE__*/React.cloneElement(action, {
            key: index
          }))
        })]
      }), /*#__PURE__*/_jsx(Space, {
        className: "desc",
        children: desc === null || desc === void 0 || (_desc$filter = desc.filter(c => c)) === null || _desc$filter === void 0 ? void 0 : _desc$filter.map((c, i) => /*#__PURE__*/_jsxs(React.Fragment, {
          children: [i > 0 && /*#__PURE__*/_jsx("div", {
            className: "divider"
          }), c]
        }, i))
      })]
    })]
  });
};
export default DetailTitle;